import React from "react";
import styled, { css } from "styled-components";
import distances from "styles/distances.js";
import mediaQuery from "styles/mediaQuery";
import typographySizes from "styles/typographySizes.js";
import colors from "styles/colors.js";
import { Link as ScrollLink, animateScroll as scroll } from "react-scroll";
import { Link } from "gatsby";

//assets
import arrowIcon from "assets/svg/arrow-btn.svg";

const sharedStyles = css`
  color: inherit;
  display: flex;
  align-items: center;
  text-decoration: none;
  flex: 0 0 auto;
min-height: 4.2rem;
min-width: 4.2rem;
  .arrow-right {
    width: 0rem;
    height: 0rem;
    
    }
  &:hover {
    .arrow-left {
      width: 0rem;
      height: 0rem;
      transition: all 0.3s ease-in-out;
    }
    .arrow-right {
      width: 4.2rem;
      height: 4.2rem;
      transition: all 0.3s ease-in-out;
    }
  }
`;

const StyledLink = styled.a`
  ${sharedStyles}
`;

const StyledGatsbyLink = styled(Link)`
  ${sharedStyles}
`;

const StyledScrollLink = styled(ScrollLink)`
  ${sharedStyles}
`;

const ArrowWrapper = styled.div` 
  width: 4.2rem;
  height: 4.2rem;
  background-color: ${props => props.color || colors.yellow};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease-in-out;
`;

const ArrowIcon = styled.img`


`;

const TextWrapper = styled.span`
  color: ${colors.dark};
  background-color: ${props => props.color || colors.yellow};
  height: 4.2rem;
  line-height: 4.2rem;
  font-size: ${typographySizes.text.tekstSize1.size.desktop}rem;
  display: inline-block;
  padding: 0 2rem;
  border-radius: 7rem;
  white-space: nowrap;
flex: 0;
`;

const Btn = ({ color, scroll, pageLink, to, children, href, noText, ...props }) => {
  const content = (
    <>
      <ArrowWrapper className="arrow-left" color={color}>
        <ArrowIcon src={arrowIcon} alt="Arrow" />
      </ArrowWrapper>
      { !noText && <TextWrapper color={color}>{children}</TextWrapper> }
      <ArrowWrapper className="arrow-right" color={color}>
        <ArrowIcon src={arrowIcon} alt="Arrow" />
      </ArrowWrapper>
    </>
  );

  if (scroll) {
    return (
      <StyledScrollLink color={color} to={to} smooth={true} duration={500} {...props}>
        {content}
      </StyledScrollLink>
    );
  }

  if (pageLink) {
    return (
      <StyledGatsbyLink color={color} to={to} {...props}>
        {content}
      </StyledGatsbyLink>
    );
  }

  return (
    <StyledLink color={color} href={href} {...props}>
      {content}
    </StyledLink>
  );
};

export default Btn;
